import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICategoryResponse } from "../models/Part";
import useCategoriesMutations from "./useCategoriesMutations";

export default function useCategories() {
  const { get } = useApiHelper();
  const { create, update, bulkUpdatePartCategories, bulkAcceptPartCategories } = useCategoriesMutations();

  const categories = useQuery({
    queryKey: ["categories"],
    queryFn: () => get<ICategoryResponse>("/part/categories"),
    staleTime: 1000 * 60 * 10, //10 minutes
  });

  return {
    categories,
    create,
    update,
    bulkUpdatePartCategories,
    bulkAcceptPartCategories
  };
}
